import type { AvailableRepositoriesResponse } from '@this/components/admin/organizations/types';
import React, { useState } from 'react';
import _ from 'lodash';

type Props = {
  selectableRepos: AvailableRepositoriesResponse[];
  currentRepos: AvailableRepositoriesResponse[];
};

type State = string[];
type CategoryType = AvailableRepositoriesResponse['category'];
type RepoType = AvailableRepositoriesResponse['repository'];

const CATEGORY_DISPLAY_NAME: { [key in CategoryType]: string } = {
  foreign_hotel: '海外ホテル',
  domestic_hotel: '国内ホテル',
  foreign_flight: '海外航空券',
  domestic_flight: '国内航空券',
  domestic_flight_package: '国内航空券パッケージ',
  domestic_railway: '国内鉄道',
  domestic_railway_package: '国定鉄道パッケージ',
  rentalcar: 'レンタカー'
};
const REPO_DISPLAY_NAME: { [key in RepoType]: string } = {
  ean_rapid: 'Expedia',
  net_rate_eps_rapid: 'Expedia(ネットレート対応)',
  rakuten_hotel: '楽天ホテル',
  rakuten_static_file_hotel: '楽天ホテル(static file)',
  amadeus: 'amadeus',
  travelport: 'travelport',
  sakura: 'AITravel',
  travel_west: 'travel_west',
  jal: 'JAL',
  ana: 'ANA',
  domestic_air_cache: '国内航空券キャッシュ',
  rakuten_package: '楽天パッケージ',
  shinkansen: '新幹線',
  jr_package: 'JRパッケージ',
  smas: 'SMAS',
  agoda: 'Agoda',
  hotel_skip: 'ホテルスキップ'
};

const SEPARATOR = '|';

const genUniqueValue = (category: CategoryType, repo: RepoType) => `${category}${SEPARATOR}${repo}`;

const isChecked = (state: State, category: CategoryType, repo: RepoType) =>
  state.includes(genUniqueValue(category, repo));

const AvailableRepositoriesForm: React.FC<Props> = ({ selectableRepos, currentRepos }) => {
  const reposByCategory = _.groupBy(selectableRepos, repo => repo.category);
  const [state] = useState<State>(currentRepos.map(v => genUniqueValue(v.category, v.repository)));
  return (
    <div style={{ paddingLeft: '10px' }}>
      {Object.keys(reposByCategory).map(category => (
        <div
          key={category}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: category !== Object.keys(reposByCategory)[0] ? '10px' : '0'
          }}
        >
          <label style={{ width: '160px' }}>{CATEGORY_DISPLAY_NAME[category]}:</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {reposByCategory[category].map((repo, i) => {
              return (
                <label key={i}>
                  <input
                    type="checkbox"
                    value={genUniqueValue(category, repo.repository)}
                    checked={isChecked(state, category, repo.repository)}
                    disabled
                  />
                  {REPO_DISPLAY_NAME[repo.repository]}
                </label>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AvailableRepositoriesForm;
